// Client-side port of api/src/services/channelSuggester.js — tags manual prospects.

/**
 * @param {object} prospect
 * @param {'people_search'|'google_maps'|string} searchSource
 * @returns {{ channel: 'email'|'whatsapp'|'sms'|'linkedin'|'none', reason: string }}
 */
export function suggestChannel(prospect, searchSource) {
  const email = String(prospect?.email || '').trim();
  const phone = String(prospect?.phone || '').trim();
  const linkedinUrl = String(prospect?.linkedinUrl || '').trim();

  if (searchSource === 'people_search') {
    if (email) return { channel: 'email', reason: 'Email on file' };
    if (phone) return { channel: 'whatsapp', reason: 'Phone on file' };
    if (linkedinUrl) return { channel: 'linkedin', reason: 'LinkedIn profile found' };
    return { channel: 'none', reason: 'No contact info' };
  }

  if (searchSource === 'manual' || !searchSource) {
    if (email) return { channel: 'email', reason: 'Manually added' };
    if (phone) return { channel: 'whatsapp', reason: 'Manually added' };
    return { channel: 'none', reason: 'Manually added' };
  }

  // google_maps
  if (phone) return { channel: 'whatsapp', reason: 'Phone via Google Maps' };
  return { channel: 'none', reason: 'No contact info' };
}
